<template>
  <div class="eligibility-sex">
    <template v-if="isOnboardingRedesign">
      <h2 class="question-title with-subtext">
        Please select the sex assigned to you at birth.
      </h2>
      
      <p class="sub-text group-mb tw-mt-4">
        Your sex assignment helps us determine if you’re eligible for treatment.
      </p>
    </template>
    <template v-else>
      <h2 class="question-title with-subtext">
        What was the sex assigned to you at birth?
      </h2>
      <p class="sub-text group-mb">
        Your sex assignment helps us to determine if you are eligible for
        treatment.
      </p>
    </template>
    
    <w-checkbox
      id="sex-female"
      v-model="sex"
      class="fs-exclude"
      type="radio"
      value="Female"
      label="Female"
      @change="submitAnswer"
    />
    <w-checkbox
      id="sex-male"
      v-model="sex"
      class="fs-exclude"
      type="radio"
      value="Male"
      label="Male"
      @change="submitAnswer"
    />
    <img
      :src="isOnboardingRedesign ? require(`@/assets/images/cro/hsa-fsa-eligible-badge.svg`) : require(`@/assets/images/cro/hsa-fsa-eligible-badge.png`)"
      alt=""
      class="tw-mx-auto"
      :class="isOnboardingRedesign ? 'tw-h-[30px]' : 'tw-h-[18px]'"
    >
    <OnboardingCTAContainer>
      <div
        v-if="sex"
        class="tw-w-full tw-flex tw-flex-col tw-gap-2"
      >
        <b-button
          block
          class="slight-rounded"
          :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
          pill
          variant="info"
          @click="submitAnswer"
        >
          Continue
        </b-button>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex'

// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer.vue';
import analyticsMixin from '@/mixins/analytics';

export default {
  components: {
    OnboardingCTAContainer,
  },
  mixins: [analyticsMixin],
  props: ['age', 'onboardingflow', 'preAnswer'],
  data() {
    return {
      sex: '',
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign', 'isSoftRejected']),
    ...mapState('onboarding', ['onboardingPatient']),

  },
  async mounted() {
    if (this.preAnswer) {
      this.sex = this.preAnswer;
    }

    await this.$_analytics_track(
      'Onboarding Screen Viewed',
      {
        screen: '1.3-A',
        onboardingflow: this.onboardingflow,
      },
    );
  },
  methods: {
    async submitAnswer() {
      this.$emit('setParams', 'gender', this.sex);
      if (this.sex == 'Male') {
        this.$emit('setStep', 'male');

        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            screen: '1.3.2-A',
            onboardingflow: this.onboardingflow,
          },
        );
      } else if (this.sex == 'Female' && this.age < 35 && !['H', 'J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingPatient.flow_variant)) {
        this.$emit('setStep', 'surgery');
        await this.$_analytics_track(
          'Onboarding Screen Viewed',
          {
            screen: '1.3.1-A',
            onboardingflow: this.onboardingflow,
          },
        );
      } else {
        // this.$emit('showLoader', 4);
        this.$emit('checkToken');
        if (this.isSoftRejected) {
          this.$emit('setStep', 'medicalConditionsSoftRejection');
        } else {
          this.$emit('setStep', 'registration');
        }
      }
    },
  },
};
</script>

<style></style>
